import validationMessages from './constants';

export default class Validator {
  static checkValidation({ element, type }) {
    element.setCustomValidity("");

    let validators = {};

    if (validationMessages) {
      for (let validationKey in validationMessages) {
        validators[validationKey] = validationMessages[validationKey];
      }
    }

    // check element validity for issues and serve defined validation message based on either set constants or provided custom messages
    for (let validationKey in element.validity) {
      let validationMessage = '';

      // Check for validation messages unique to this field type
      if (validators.fields && validators.fields.input && validators.fields.input[type] && validators.fields.input[type][validationKey]) {
        validationMessage = validators.fields.input[type][validationKey];
        // Check for default validation messages
      } else {
        validationMessage = validators[validationKey];
      }

      if (!!validationMessage && element.validity[validationKey]) {
        return validationMessage;
      };
    };

    return "";
  }

  static setValidState({ element, message }) {
    element.setCustomValidity(message);
  }

  // Validates past date based on midnight between yesterday and today
  static isValidPastDate({ date }) {
    const formattedDate = new Date(date);
    const today = new Date();

    today.setHours(0);
    today.setMinutes(0);
    return this.isValidDate(date) && today.getTime() > formattedDate.getTime();
  }

  // Validates future date based on midnight between today and tomorrow
  static isValidFutureDate({ date }) {
    const formattedDate = new Date(date);
    const today = new Date();

    // Set date to tomorrow
    today.setHours(0);
    today.setMinutes(0);
    today.setDate(today.getDate() + 1);
    return this.isValidDate(date) && today.getTime() < formattedDate.getTime();
  }

  // Validates past date based on midnight between today and tomorrow
  static isValidPastInclusiveDate({ date }) {
    const formattedDate = new Date(date);
    const today = new Date();

    // Set date to nearly midnight
    today.setHours(23);
    today.setMinutes(59);
    return this.isValidDate(date) && today.getTime() > formattedDate.getTime();
  }

  // Validates future date based on midnight between yesterday and today
  static isValidFutureInclusiveDate({ date }) {
    const formattedDate = new Date(date);
    const today = new Date();

    today.setHours(0);
    today.setMinutes(0);
    return this.isValidDate(date) && today.getTime() < formattedDate.getTime();
  }

  // Validates date in YYYY-MM-DD format
  static isValidDate({ date }) {
    const [year, month, day] = date.split('-');
    const formattedDate = new Date(date);

    // If no day month or year, not valid
    if (!day || day === '' || !month || month === '' || !year || year === '') {
      return false;
    }

    // If special characters or letters, not valid
    if (!this.isValidNumeric({ value: day }) || !this.isValidNumeric({ value: month }) || !this.isValidNumeric({ value: year })) {
      return false;
    }

    // If month and year out of range, not valid
    const parsedYear = parseInt(year);
    const parsedMonth = parseInt(month);

    if (!parsedYear || parsedYear < 1000 || parsedYear > 9999 || !parsedMonth || parsedMonth > 12) {
      return false;
    }

    // Check date is a Date, can be converted to a timestamp and the month is the same as the user entered
    return formattedDate instanceof Date && !isNaN(formattedDate.getTime()) && formattedDate.getUTCMonth() + 1 === parseInt(month);
  }

  // Validates value is alphanumeric, no special characters
  static isValidAlphaNumeric({ value }) {
    const alphanumericRegEx = /[^a-z\d]/i;
    return !(alphanumericRegEx.test(value));
  }

  // Validates value is numeric, no special characters
  static isValidNumeric({ value }) {
    const numericRegEx = /^\\d*$/;
    return !(numericRegEx.test(value)) && !isNaN(value);
  }

  // Validates value is alpha, no special characters or numbers
  static isValidAlpha({ value }) {
    const numericRegEx = /[^A-Za-z]/i;
    return !(numericRegEx.test(value));
  }

  // Validates value is alpha, no special characters or numbers, minimum 8 characters
  static isValidPassword({ value, pattern }) {
    const passwordRegEx = pattern || /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/;
    return !(passwordRegEx.test(value));
  }
}
